import styled from '@emotion/styled';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 1em 0;

    >ul {
        display: flex;
        justify-content: center;
        align-items: center;

        @keyframes next {
            0% {
                transform: translateX(0)
            }

            50% {
                transform: translateX(1em)
            }

            100% {
                transform: translate(0)
            }
        }

        @keyframes prev {
            0% {
                transform: translateX(0)
            }

            50% {
                transform: translateX(-1em)
            }

            100% {
                transform: translate(0)
            }
        }

        .next {
            &:hover {
                animation: next .6s ease-in;
            }
        }

        .previous {
            &:hover {
                animation: prev .6s ease-in;
            }
        }

        .next,
        .previous {
            position: relative;

            &:after {
                content: "";
                position: absolute;
                width: 150%;
                height: 150%;
                left: 50%;
                transform: translateX(-50%);
                top: -25%;
                z-index: -1;
            }
        }

        >li {
            margin: 0 .3em;
            list-style: none;
            font-size: 1.12em;
            cursor: pointer;

            a {
                color: #000000;
                text-decoration: none;
                transition: opacity .3s ease-in-out;
            }

            &.selected {
                a {
                    font-weight: 600;

                }
            }

            &:hover {
                a {
                    opacity: .4;
                }
            }

            .next-icon,
            .prev-icon {
                color: #000000;
                margin: 0 .6em;
            }

        }
    }

`;